import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Clubs.css';
import { getCorrectListClub } from '../variables';
import PageHero from '../components/PageHero';

function Clubs({to = "clubs"}) {
    const navigate = useNavigate();
    const [clubs, setClubs] = useState([]);

    // on récupère le championnat dans l'URL
    const championnat = useLocation().pathname.split('/')[1];

    useEffect(() => {
        const list = getCorrectListClub(championnat) || [];
        setClubs(list);
    }, [championnat])

    // plus d'appel direct à l'API ici; on s'aligne sur les listes mémoire utilisées pour construire les routes

    const resolveSlug = (item) => item.short

    const handleOnClick = (event, value) => {
        let onglet = 1;
        event.preventDefault();

        switch (to) {
            case 'clubs':
                onglet = 4
                break;
            case 'joueurs':
                onglet = 1;
                break;
            default:
                break;
        }

        navigate('/' + championnat + '/' + value, {state:{onglet: onglet}});
    }

    const isJoueurs = to === 'joueurs';

    return (
        <div className={"clubs_page " + championnat}>
            <PageHero
                championnat={championnat}
                title={isJoueurs ? 'Joueurs' : 'Clubs'}
                subtitle={isJoueurs ? "Choisissez un club pour découvrir son effectif" : "Choisissez un club pour voir ses contacts et sa salle"}
            />

            <div className="clubs_list_clubs">
                {
                    clubs.length > 0 &&
                    [...clubs].sort((a, b) => (a.title || '').localeCompare(b.title || '')).map((item) => {
                        return (
                            <button
                                type="button"
                                key={item.id}
                                className="clubs_club_container"
                                onClick={(e)=>handleOnClick(e, resolveSlug(item))}
                            >
                                <span className="clubs_club_logo">
                                    <img
                                        src={process.env.PUBLIC_URL + "/images/clubs/" + (item.photo || item.photoClub)}
                                        alt=""
                                        loading="lazy"
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src=process.env.PUBLIC_URL + "/images/no-pictures.png";
                                        }}
                                    />
                                </span>
                                <span className="clubs_club_name">{item.title}</span>
                                {
                                    item.ville &&
                                    <span className="clubs_club_ville">{item.ville}</span>
                                }
                                <span className="clubs_club_cta">
                                    {isJoueurs ? "Voir l'effectif" : "Voir le club"} <span aria-hidden="true">→</span>
                                </span>
                            </button>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Clubs;